import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100" role="contentinfo">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h3 className="text-lg font-heading font-bold text-background-50 mb-4">韩漫之家</h3>
            <p className="text-sm text-foreground-300 leading-relaxed">
              国内领先的韩国漫画在线免费阅读平台。海量韩漫资源，无遮挡下拉式阅读，每日更新，免费畅享。
            </p>
          </div>
          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              <a href="#quick-links">快速链接</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">漫画分类</Link></li>
              <li><Link to="/category/romance" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">恋爱韩漫</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">奇幻韩漫</Link></li>
              <li><Link to="/category/action" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">动作韩漫</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              <a href="#about-info">关于我们</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">商务合作</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">联系我们</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              <a href="#contact-info">联系方式</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-mail-line text-primary-400"></i>
                hello@bferj.cn
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-phone-line text-primary-400"></i>
                400-888-8888
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-map-pin-line text-primary-400"></i>
                北京市朝阳区望京SOHO
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2019-2026 韩漫之家 bferj.cn 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="http://bferj.cn/" target="_blank" rel="nofollow noopener" className="text-foreground-400 hover:text-primary-400 transition-colors" aria-label="微博">
              <i className="ri-links-line text-lg"></i>
            </a>
            <a href="http://bferj.cn/" target="_blank" rel="nofollow noopener" className="text-foreground-400 hover:text-primary-400 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
